module.exports = __webpack_public_path__ + "img/1_027.5992a0a9.jpg";